export class StorageRoutes
{
    static Home: string = "/";
    // storage
    static StorageList: string = "/storage/list";
    static StorageNew: string = "/storage/new";
    static StorageView(id: string)
    {
        return `/storage/${id}/view`;
    }
    static StorageEdit(id: string)
    {
        return `/storage/${id}/edit`;
    }
    static StorageCopy(id: string)
    {
        return `/storage/${id}/copy`;
    }
    // storage user
    static StorageUserList: string = "/storage/user/list";
    static StorageUserNew: string = "/storage/user/new";
    static StorageUserView(id: string)
    {
        return `/storage/user/${id}/view`;
    }
    static StorageUserEdit(id: string)
    {
        return `/storage/user/${id}/edit`;
    }
    static StorageUserCopy(id: string)
    {
        return `/storage/user/${id}/copy`;
    }
    // assignment
    static AssignmentList: string = "/assignment/list";
    static AssignmentNew: string = "/assignment/new";
    static AssignmentView(id: string)
    {
        return `/assignment/${id}/view`;
    }
    static AssignmentEdit(id: string)
    {
        return `/assignment/${id}/edit`;
    }
    static AssignmentCopy(id: string)
    {
        return `/assignment/${id}/copy`;
    }
}